import { makeVar } from '@apollo/client';

export const OPENED_MODAL = makeVar<null | string>(null);
export const FEEDBACK_OPEN = makeVar<boolean>(false);
export const REFETCH_APP_SETTINGS = makeVar<boolean>(false);
